/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Dashboard_Kpi_OrgsInputs */



/**
* | output |
* | --- |
* | "Organizations" |
*
* @param {Partner_Dashboard_Kpi_OrgsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_dashboard_kpi_orgs = /** @type {((inputs?: Partner_Dashboard_Kpi_OrgsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Dashboard_Kpi_OrgsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Organisationen")
	return /** @type {LocalizedString} */ ("Organizations")
});